/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Ma', // 'Today',
  now: 'Most', // 'Now',
  backToToday: 'Vissza a mai napra', // 'Back to today',
  ok: 'Ok',
  clear: 'Törlés', // 'Clear',
  month: 'Hónap', // 'Month',
  year: 'Év', // 'Year',
  timeSelect: 'Időpont kiválasztása', // 'Select time',
  dateSelect: 'Dátum kiválasztása', // 'Select date',
  monthSelect: 'Hónap kiválasztása', // 'Choose a month',
  yearSelect: 'Év kiválasztása', // 'Choose a year',
  decadeSelect: 'Évtized kiválasztása', // 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'YYYY/MM/DD', // 'M/D/YYYY',
  dayFormat: 'DD', // 'D',
  dateTimeFormat: 'YYYY/MM/DD HH:mm:ss', // 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Előző hónap (PageUp)', // 'Previous month (PageUp)',
  nextMonth: 'Következő hónap (PageDown)', // 'Next month (PageDown)',
  previousYear: 'Múlt év (Control + left)', // 'Last year (Control + left)',
  nextYear: 'Jövő év (Control + right)', // 'Next year (Control + right)',
  previousDecade: 'Előző évtized', // 'Last decade',
  nextDecade: 'Következő évtized', // 'Next decade',
  previousCentury: 'Múlt évszázad', // 'Last century',
  nextCentury: 'Jövő évszázad' // 'Next century',
};
